
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import get from 'lodash/get';

import Text from '../../common/client/components/Text';

import { getToken } from '../../reducers/auth';
import { getProjectId } from '../../reducers/project';
import knDataGetActions from '../../sagas/knData';
import projectGetActions from '../../sagas/project';

import theme from '../common/theme';
import DialogConfirm from '../common/DialogConfirm';
import ToolbarCommandButton from '../projectMapPage/ToolbarCommandButton'; // ToDo
import OverviewPanel from './OverviewPanel';

const classNames = mergeStyleSets({
    section: {
        paddingBottom: 16
    },
    sectionTitle: {
        paddingTop: 4,
        paddingBottom: 4
    },
    sectionContent: {
        paddingLeft: 16
    },
    title: {
        paddingBottom: 8
    },
    item: {
        paddingButton: 4
    },
    content: {
        paddingTop: 16
    },
    nazev: {
        width: 200
    },
    parc: {

    }
});

const Section = (props) => {
    return (
        <div className={classNames.section}>
            <div className={classNames.sectionTitle} >
                <Text medium bold color={theme.fabricTheme.palette.neutralTertiary}>{props.title}</Text>
            </div>
            <div className={classNames.sectionContent} >
                {props.children}
            </div>
        </div>
    );
}

const KnDataItem = (props) => {
    return (
        <Stack horizontal tokens={{childrenGap: 8}} className={classNames.item}>
            <Stack.Item grow className={classNames.nazev}>
                <Text {...props.textProps}>{props.item.nazev}</Text>
            </Stack.Item>
            <Stack.Item className={classNames.parc}>
                <Text {...props.textProps}>{props.item.par_count}</Text>
            </Stack.Item>
        </Stack>
    );
}

const KnData = (props) => {
    return (
        <Section title="KATASTRÁLNÍ DATA">
            <div className={classNames.title}>
                <KnDataItem
                    item={{nazev: 'Název katastrálního území', par_count: 'Počet parcel'}}
                    textProps={{bold: true}}
                />
            </div>
            {props.knDataItems.map(item => {
                return <KnDataItem key={item.kod} item={item} />
            })}
        </Section>
    );
}

const SourceDataItem = (props) => {
    return (
        <Stack horizontal tokens={{childrenGap: 8}} className={classNames.sourceItem}>
            <Stack.Item grow className={classNames.sourceTitle}>
                <Text>{props.title}:</Text>
            </Stack.Item>
            <Stack.Item className={classNames.sourceValue}>
                <Text bold={true}>{props.value}</Text>
            </Stack.Item>
        </Stack>
    );
}

const SourceData = (props) => {
    const sourceTypeText = (props.project.params.sourceType === '1')
        ? 'webHONITBA'
        : 'Neznámý';

    return (
        <Section title="ZDROJ DAT">
            <SourceDataItem title="Typ zdroje dat" value={sourceTypeText} />
            <SourceDataItem title="ID zdroje dat" value={props.project.params.sourceId} />
        </Section>
    );
}

const OverviewPanelInputData = (props) => {

    const dispatch = useDispatch();
    const knDataActions = knDataGetActions(dispatch);
    const projectActions = projectGetActions(dispatch);

    const token = useSelector(state => getToken(state));
    const projectId = useSelector(state => getProjectId(state));

    const project = useSelector(state => {
        return get(state.project, 'data.project', {});
    });

    const knData = useSelector(state => {
        return state.knData;
    });

    const knDataItems = get(knData, 'data.result.items', []);

    useEffect(() => {
        if (!knData.loaded && !knData.loading) {
            knDataActions.get(token, projectId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [knData]);

    const handleUpdateDataClick = async () => {
        const message = `Opravdu chcete aktualizovat data ze zdrojových dat?"`;

        let confirm = await DialogConfirm.show(message);
        if (confirm) {
            projectActions.updateDataFromSource(token, projectId);
        }
    }

    return (
        <OverviewPanel title="VSTUPNÍ DATA" loaded={knData.loaded}>
            <SourceData project={project} />
            <KnData knDataItems={knDataItems} />
            <ToolbarCommandButton items={[
                {
                    text: 'Aktualizace dat ze zdroje',
                    title: 'Aktualizovat data ze zdrojových dat',
                    onClick: handleUpdateDataClick
                }
            ]}/>
        </OverviewPanel>
    );
}

export default OverviewPanelInputData;
